<template>
  <div>
    <v-list-tile v-if="list" @click.capture.stop="$refs.metadata.show()">
      <v-list-tile-action>
        <v-icon color="primary">info</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        {{ $t('message.metadata.moreInfo') }}
      </v-list-tile-content>
    </v-list-tile>
    <nx-entity-metadata-button ref="metadata" :id="id" :type="type" :hidden="list"/>
  </div>
</template>

<script>
import NxEntityMetadataButton from '@/modules/entity/metadata/EntityMetadataButton';

export default {
  name: 'nx-list-action-metadata',
  components: {
    NxEntityMetadataButton,

  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    list: {
      type: Boolean,
    },
  },
};
</script>
